<template>
    <svg
        :width="`${width}px`"
        :height="`${height}px`"
        viewBox="0 0 100 100"
    >
        <polyline
            :fill="color"
            :stroke="0"
            stroke-width="15"
            :points="direction"
        />
    </svg> 
</template>

<script>
// Mixins
import styles from '../mixins/styles';

// Types
import {
    chevronColors,
    chevronDefaultColor,
    chevronDirections,
    chevronDefaultDirection
} from '../types/Chevron.types';

import { eligibleProp } from '../utils/props-utils';

export default {
    name: 'Chevron',
    mixins: [styles],
    props: {
        width: {
            type: Number,
            default: 0,
        },
        height: {
            type: Number,
            default: 0,
        },
        color: {
            type: String,
            default: chevronDefaultColor,
            validator: eligibleProp(chevronColors)
        },
        direction: {
            type: String,
            default: chevronDefaultDirection,
            validator: eligibleProp(chevronDirections)
        }
    },
}
</script>